angular.module('app.ctrls').directive('blockArrowsScroll', [
    function () {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var $element = $(element);
                var arrow_keys_handler = function (e) {
                    // Don't alter inputs behaviour
                    if (e.target.localName !== 'input' && e.target.localName !== 'textarea') {
                        switch (e.keyCode) {
                            case 37:
                            case 39:
                            case 38:
                            case 40: // Arrow keys
                            case 32:
                                e.preventDefault();
                                break; // Space
                            default:
                                break; // do not block other keys
                        }
                    }
                };
                $element[0].addEventListener('keydown', arrow_keys_handler, false);
            }
        };
    }
]);
